import React from "react";
import cn from "classnames";

const SalesTabContent = (props) => {
  return (
    <div
      className={cn("tab-pane fade", props.className)}
      id={props.id}
      role="tabpanel"
      aria-labelledby={props.ariaLabel}
    >
      <div className="chart-content-inner">
        <h2 className="title">{props.title}</h2>
        <p>{props.description}</p>

        {/* حاوية الأزرار بمحاذاة أفقية */}
        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
          {/* زر NOWPayments يفتح صفحة خارجية في نفس النافذة */}
          <a 
            href="https://www.gempad.app/presale/0x292fE114F5edc0409499C3D0DE7fD83E7b0D1984/?network=BNB_Smart_Chain&refer=0x04ea3502E1c9f7f96cDf388413af9deFE13202E0" 
            className="btn" 
            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            Buy Now
          </a>

          {/* زر Wallet Connect (يمكنك تعديله بنفس الطريقة) */}
          
        </div>
      </div>
    </div>
  );
};

export default SalesTabContent;